import { type Theme, alpha } from '@mui/material';

export function getNodePalette(theme: Theme) {
	const accent = theme.palette.primary.light;
	const accentStrong = theme.palette.primary.main;
	return {
		surface: theme.palette.background.paper,
		// The node shell must remain opaque against every themed graph canvas.
		surfaceActive: theme.palette.background.paper,
		border: alpha(accent, 0.75),
		borderMuted: theme.palette.divider,
		accent,
		accentStrong,
		text: theme.palette.text.primary,
		textMuted: theme.palette.text.secondary,
		itemSurface: alpha(accentStrong, 0.22),
		itemSurfaceMuted: alpha(theme.palette.text.secondary, 0.12),
		itemSurfaceHint: alpha(accentStrong, 0.16),
		itemSurfaceStrongHint: alpha(accentStrong, 0.24),
		emptySurface: theme.palette.action.hover,
		emptyBorder: theme.palette.divider,
		actionSurface: theme.palette.background.default,
		contrast: theme.palette.primary.contrastText,
		error: theme.palette.error.main,
		highlightShadow: `0 4px 16px ${alpha(accentStrong, 0.38)}`,
		hoverShadow: `0 4px 14px ${alpha(accentStrong, 0.24)}`,
		defaultShadow: `0 2px 8px ${alpha(theme.palette.common.black, 0.3)}`,
		itemHighlightShadow: `0 0 0 2px ${alpha(accentStrong, 0.32)}`,
		itemInsetShadow: `inset 0 0 0 1px ${alpha(accentStrong, 0.08)}`,
	};
}
